<template>
  <div>
    <FilterItem :offset-top="filterOffsetTop" :display="display" @onClick="onFilterItemClick"  :styleStoreType ="styleStoreType" @ongetSwitchStyle="getSwitchStyle" />
    <div class="nod" v-if="noShowNoneDataFlag">
      <span>没有找到相关商品，以下是为您推荐的本店的其他商品</span>
    </div>
    <div class="cat0">
      <button
        :class="['cat1', {'cat1_a': cate.isSelect}]"
        v-for="(cate, index) in hengList"
        :key="index"
        @click="changeCategoryFun(cate, index)"
      >
        {{cate.categoryName}}
        <img
          class="mark"
          v-show="cate.isSelect"
          src="@/assets/image/mode-active.png"
        />
      </button>
    </div>

    <van-list v-model="loading" :finished="finished" finished-text="" @load="onLoad" v-if="!isstyle">
      <div class="stc0">
        <div class="ul">
          <div
            class="li"
            v-for="(item,index) in dataList"
            :key="index"
            @click="toComodity(item)"
            v-if="index%2==0"
          >
            <div v-if="item.indexImage && item.indexImage.imageUrl" style="position: relative;">
              <img v-if="item.type == 'DISCOVER'" class="tag_img" src="@/assets/brand/wenwen.png" />
              <img v-if="item.type == 'PRODUCT' && goodsActivityInfo.coverImageUrl" class="tag_img_bg" :src="goodsActivityInfo.coverImageUrl" />
              <van-image
                :src="item.indexImage && item.indexImage.imageUrl + '?x-oss-process=style/style_shareatlas_img'"
                fit="contain"
                lazy-load
              >
                <template v-slot:loading>
                  <img class="img1" :src="loadingImg" />
                </template>
              </van-image>
                <!-- 调价标识 -->
               <img mode="widthFix" class="modifypricetips"   v-if="item.promotionUrl"  :src="item.promotionUrl" />
            </div>
            <div v-else>
              <img class="img1" :src="loadingImg" />
            </div>
            <div class="text">
              <div class="zi">{{item.itemName || item.title}}</div>
              <div v-if="item.price" class="pic">
                <span>￥{{item.price}}</span>
                <span class="markingPrice" v-show="item.markingPrice">￥{{item.markingPrice}}</span>
              </div>
              <div class="dsct" v-if="item.discountStairDesc">{{item.discountStairDesc}}</div>
            </div>

          

          </div>
        </div>
        <div class="ul">
          <div
            class="li"
            v-for="(item,index) in dataList"
            :key="index"
            @click="toComodity(item)"
            v-if="index%2!=0"
          >
            <div v-if="item.indexImage && item.indexImage.imageUrl" style="position: relative;">
              <img v-if="item.type == 'DISCOVER'" class="tag_img" src="@/assets/brand/wenwen.png" />
              <img v-if="item.type == 'PRODUCT' && goodsActivityInfo.coverImageUrl" class="tag_img_bg" :src="goodsActivityInfo.coverImageUrl" />
              <van-image
                :src="item.indexImage && item.indexImage.imageUrl + '?x-oss-process=style/style_shareatlas_img'"
                fit="contain"
                lazy-load
              >
                <template v-slot:loading>
                  <img class="img1" :src="loadingImg" />
                </template>
              </van-image>

               <!-- 调价标识 -->
               <img mode="widthFix" class="modifypricetips"   v-if="item.promotionUrl"  :src="item.promotionUrl" />
            </div>
            <div v-else>
              <img class="img1" :src="loadingImg" />
            </div>
            <div class="text">
              <div class="zi">{{item.itemName || item.title}}</div>
              <div v-if="item.price" class="pic">
                <span>￥{{item.price}}</span>
                <span class="markingPrice" v-show="item.markingPrice">￥ {{item.markingPrice}}</span>
              </div>
              <div class="dsct" v-if="item.discountStairDesc">{{item.discountStairDesc}}</div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <van-list v-model="loading" :finished="finished" finished-text="" @load="onLoad" v-else>
      <goods-column :list = "dataList" :goodsActivityInfo="goodsActivityInfo"/>
    </van-list>

    
  <!-- 没有数据的情况 -->
  <div class="block_nodata" v-if="dataList.length == 0">
    <img  class="img" src="@/assets/store-null.png" alt=""/>
		<div class="info">暂无相关商品</div>
	</div>

    

    <!-- 此处放入 一行的样式-->
  </div>
</template>
<script>
import FilterItem from '@/components/filter/item'
import http from "@/utils/axios";
import utils from "@/utils/common";
import goodsColumn from "./brand-goods-column.vue"
export default {
  name: "branch-index-list",
  props: {
    branchid: {
      type: [Number, String]
    },
    filterOffsetTop: {
      type: Number,
      default: 100
    },
    goodsActivityInfo:{
      type:Object,
      default:function(){
        return {}
      }
    },
    styleStoreType:{
      type:Boolean,
      default:false,
    }
  },

  watch: {

  },
  data() {
    return {
      loading: false,
      finished: false,
      pageIndex: 1,
      pageSize: 10,
      dataList: [],
      //是否显示右边弹窗，默认是显示的，从搜索界面调用此组件不展示
      showRightMode: true,
      noShowNoneDataFlag: false,
      //关键字
      keyword: "",
      // 购买方式
      type: [],
      //控制弹窗
      // visible: false,
      typeFormat: {
        PRODUCT: "/h5user/commoditydetails?id=",
        DISCOVER: "/h5user/discoverUserDetails?id="
      },
      publishTypeFormat: {
        NORMAL: "/h5user/discoverUserDetails?id=",
        ATLAS: "/h5user/atlasProductDetail?discoverId="
      },
      typeFormat2: {
        DISCOVER: "/discoverUserDetails",
        PRODUCT: "/commoditydetails"
      },
      hengList:[],
      hengListFlag: false,
      display: {
        three: { name: '价格', showIcon: true },
        four: { active: false, show: true }
      },
      isstyle:false,    //是否切换样式
      sizeIdList:[],
      loadingImg:this.$theme.u_goods_icon_default || require('@/assets/loadingBG.png')
    };
  },
  methods: {
    onLoad() {
      const query = this.$route.query;
      this.showNoDataFlag = false;
      if(this.hengListFlag) {
        //重置筛选抽屉的分类
        const drawer = this.$el.__drawer__
        drawer && drawer.resetCategories(state => this.display.four.active = state)
      } else {
        this.hengList.forEach(item => item.isSelect = false)
      }
      let topDatas = []
      if(query.goodsId) {
        topDatas.push({
          extraScore: 0, // 排序
          id: query.goodsId, // 商品id
          type: 'PRODUCT' //问问DISCOVER 预置商品PRODUCT
        })
      }
      http({
        url: "search/es/branch/homepage",
        method: "post",
        parmes: {
          branchId:
            this.branchid ||
            this.$route.query.id ||
            this.$route.query.branchId ||
            this.$route.query.brandId,
          categoryLevelId3s: this.categoryLevelId3s || [],
          sizeIdList:this.sizeIdList || [],
          keyword: this.keyword || "",
          maxPrice: this.maxPrice || 0,
          minPrice: this.minPrice || 0,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          sort: this.sort || { order: '', type: '' },
          type: this.type || [],
          topDatas
        }
      }).then(rps => {
        let res = rps.data;

        //分类
        if(this.filterItemCategory === undefined) {
          if((res.filterItemCategory || []).length) {
            this.filterItemCategory = res.filterItemCategory
          }
          
          if((res.filterItemType || []).length) {
            this.filterItemType = res.filterItemType
          }
        }
      
        //加载列表
        if (res.productAndDiscovers && res.productAndDiscovers.code === 200) {
          this.$loading.hide();
          //无数据
          if (res.productAndDiscovers.pageCount == 0) {
            this.finished = true;
            return;
          }
          
          //最后一页
          if (this.pageIndex > res.productAndDiscovers.pageCount && this.pageIndex != 1) {
            this.finished = true;
            return;
          }

          //查无结果且是搜索页引用此组件时候才会展示这个提示
          if (!this.showRightMode && res.isSearchRecommend == "y") {
            this.noShowNoneDataFlag = true;
            this.dataList = [];
          }

          this.loading = false;
          this.finished = false;
          this.pageIndex++;
          this.dataList = this.dataList.concat(res.productAndDiscovers.data);
        }
        this.$loading.hide();
      });
    },
    getSwitchStyle(isstyle){
       this.isstyle = isstyle;

    },
    onFilterItemClick({ type, sort }) {
      if(type == 'four') {
        this.$filterDrawer({
          list: [{
            type: 'category',
            data: this.filterItemCategory
          },
		  // {
    //         type: 'other',
    //         alias: 'type',
    //         name: '商品类型',
    //         row: 'two',
    //         select: 'radio',
    //         data: this.filterItemType
    //       },
		  ],
          confirm: res => {
            console.log(res);
            this.sizeIdList = res.sizeIdList
            this.categoryLevelId3s = res.categories
            this.type = res.type
            this.maxPrice = res.maxPrice
            this.minPrice = res.minPrice
            this.hengListFlag = res.categories.length == 0;
            this.display.four.active = res.state
            this.setInitRequstData();
          }
        })
      } else if(type == 'five'){
          // console.log('点击了第五个')
          this.isstyle = !this.isstyle
      }else{
        this.sort = sort
        this.setInitRequstData()
      }
      
    },
    setInitRequstData() {
      this.loading = true;
      this.dataList = [];
      this.pageIndex = 1;
      this.$loading.show(); 
      this.onLoad();
    },
    toComodity(item) { 
      // let params = {
      //   id: item.refId,
      //   entryPage: "BRANCH_PAGE"
      // };
      // this.gioFun(params);
      // let url = item.type == 'DISCOVER' ? this.publishTypeFormat[item.publishType] : this.typeFormat[item.type];
      let jumpUrl = location.origin + this.typeFormat[item.type] + item.refId;
      var obj = {goodsId:parseInt(item.refId)};
      utils.jumpToNewPage({
        url: jumpUrl,
        noTitle: item.type == "PRODUCT" ? "0" : "1",
        action: item.type == "PRODUCT" ? {tm:"4030100",tp:obj} :{}
      });
    },
    changeCategoryFun(cate, index) {
      this.hengList[index].isSelect = !cate.isSelect

      this.categoryLevelId3s = []
      
      this.hengList.forEach(item => {
        if(item.isSelect) {
          this.categoryLevelId3s = this.categoryLevelId3s.concat(item.categoryIdList)
        }
      })
      
      this.hengListFlag = true;
      this.setInitRequstData();
    },
    getFilterCategoryFun(){
      http({
        url: "order/user/branch/getFilterCategory",
        method: "post",
        parmes: {branchId:
          this.branchid ||
          this.$route.query.id ||
          this.$route.query.branchId ||
          this.$route.query.brandId
        },
      }).then(rps => {
        if (rps.code == 200) {
          //组装横向滑动条数据
          if(this.hengList.length == 0){
            rps.data.forEach(el => {
              el.isSelect = false;
              this.hengList.push(el);
            });
          }
          this.$loading.hide();
        }
      }).catch((rps)=>{})
    }
  },
  created() {
    let { categoryId } = this.$route.query
    this.categoryLevelId3s = (categoryId = Number(categoryId)) ? [categoryId] : []
    this.getFilterCategoryFun();
  },
  mounted() {},
  computed: {},
  components: { FilterItem,goodsColumn }
};
</script>
<style scoped lang="less">
.modifypricetips{
  position: absolute;
  top: 10px;
  right: 10px;
  width: 70px;
  height: 70px;
  border-radius: 50%;
}
.block_nodata{
  background-color: #ffffff;
  text-align: center;
  padding-top: 80px;
  padding-bottom: 200px;
}
.block_nodata .img{
  height: 220px;
  width: 220px;
  margin: 0 auto;
}
.block_nodata .info{
  margin-top: 40px;
  font-size: 24px;
  color: #333;
}


button {
  outline: none;
  border: 0;
}
.ul {
  .div {
    display: inline-block;
    width: 250px;
    text-align: center;
    font-size: 24px;
    color: #999;
    background:#f2f2f2;
    border-radius: 10px;
    margin: 0 5px;
    .div-text {
      padding: 15px 0;
    }
  }
}
.bg-check {
  background: url(../../../assets/brand/qiba@2x.png) no-repeat !important;
  background-size:cover !important;
  color: #333 !important;
}
.stc0 {
  background-color: #f7f7f7;
  padding-top: 10px;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.stc0 .ul {
  font-size: 26px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.stc0 .li {
  font-size: 26px;
  width: 345px;
  display: flex;
  flex-direction: column;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  margin-bottom: 15px;
  background-color: #ffffff;
  position: relative;
  .tag_img {
    width: 76px;
    height: 40px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
  }
  .tag_img_bg{
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
  /deep/.van-image__img {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
}
.stc0 .li .img1 {
  max-width: 345px;
  border: 0;
  vertical-align: middle;
  margin: 0 auto;
}
.stc0 .li .text {
  margin-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 41px;
}
.stc0 .li .text .dsct{
  height: 28px;
  line-height: 28px;
  display: inline-block;
  padding: 0 12px;
  background-color: #FFE7E6;
  color: #ED3939;
  font-size: 20px;
  border-radius: 10px;
  margin-top: 10px;
}
.stc0 .li .text .zi {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  line-height: 38px;
}
.stc0 .li .text .pic {
  margin-top: 18px;
  color: #e83636;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .markingPrice {
    color: #ccc;
    text-decoration: line-through;
  }
}
.stc0 .ul .li:nth-child(even) {
  margin-right: 0;
}
.nod {
  width: 100%;
  height: 70px;
  line-height: 70px;
  text-align: center;
  background-color: #fff9e1;
  color: #f8a651;
  font-size: 24px;
}
.cat0 {
  white-space: nowrap;
  overflow-y: hidden;
  overflow-x: auto;
  padding: 0 10px 4px 10px;
  font-size: 0;
  margin-top: 10px;
  &::-webkit-scrollbar {
    display: none;
  }
  .mark {
    width: 38px;
    height: 38px;
    position: absolute;
    right: 0;
    bottom: 0;
  }
  .cat1.cat1_a {
    color: #ED3939;
    border-color: #ED3939;
  }
  .cat1 {
    display: inline-block;
    height: 60px;
    padding: 0 30px;
    color: #333;
    border-radius: 10px;
    border: 2px solid #ccc;
    box-sizing: border-box;
    font-size: 22px;
    position: relative;
    margin: 0 10px;
    background-color: #fff;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
</style>